/**
 * 工具类
 * @Description:
 *
 * @Author: JZT.Oscar
 * @Date: 2018-09-28 21:16:50
 * @Last Modified by: JZT.lmy
 * @Last Modified time: 2018-11-28 10:41:06
 */
import qs from "qs";

/* Query 字符串 序列化/反序列化
============================================================================ */
// JSON 对象 序列化 为 Query 字符串
// e.g.: JSON对象 => name=1&password=2&level=3
const toQueryString = json => qs.stringify(json);
// Query 字符串 反序列化 为 JSON 对象
// e.g.: name=1&password=2&level=3 => JSON对象
const queryToJson = str => qs.parse(str);

/* JSON 字符串 序列化/反序列化
============================================================================ */
// JSON 对象 序列化 为 JSON 字符串
// e.g.: JSON对象 =>  {"siteKeyword":"1","areaKeyword":"2","siteStatus":"2"}
const toJsonString = json => JSON.stringify(json);
// JSON 字符串 反序列化 为 JSON 对象
// e.g.: {"siteKeyword":"1","areaKeyword":"2","siteStatus":"2"} => JSON对象
const stringToJson = str => JSON.parse(str);

/* 时间格式化
// 将时间戳转换为指定格式的字符串,ie9不兼容
============================================================================ */
const formatDate = function(timespan, format = "yyyy-MM-dd hh:mm") {
    let self = new Date(timespan);// 当timespan是一个"yyyy-MM-dd hh:mm:ss"格式的字符串时，ie9无法获得正确的Date
    let date = {
        "M+": self.getMonth() + 1,
        "d+": self.getDate(),
        "h+": self.getHours(),
        "m+": self.getMinutes(),
        "s+": self.getSeconds(),
        "q+": Math.floor((self.getMonth() + 3) / 3),
        "S+": self.getMilliseconds()
    };
    if (/(y+)/i.test(format)) {
        format = format.replace(
            RegExp.$1,
            (self.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    }
    for (var k in date) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(
                RegExp.$1,
                RegExp.$1.length == 1
                    ? date[k]
                    : ("00" + date[k]).substr(("" + date[k]).length)
            );
        }
    }
    return format;
};

function createMapOfArrayByProp(arr = [], prop, repeat = 'first') {
    const map = new Map();
    if (prop) {
      arr.forEach((item) => {
        if (repeat === 'first' && map.get(item[prop])) {
          // 如果指定重复元素的第一个, 并且已经存在 直接return
          return;
        }
        map.set(item[prop], item);
      });
    }
    return map;
}
function arrayRemoveRepeatByProp(arr = [], prop, repeat = 'first') {
    let result = [];
    if (!prop) {
      result = [...new Set(arr)];
    } else {
      const map = createMapOfArrayByProp(arr, prop, repeat);
      result = [...map.values()];
    }
    return result;
}
function isNullOrDefined(v) {
    return v === undefined || v === null;
}
function difference(array1, array2) {
    const result = [];
    for (let item of array1) {
        if (!array2.includes(item)) {
            result.push(item);
        }
    }
    return result;
}
function differenceArrayByProp (array1, array2, prop) {
    const result = []
    array1.forEach(item => {
        let same = array2.some(subItem => item[prop] == subItem[prop])
        if (same == false) {
            result.push(item)
        }
    })
    return result
}

export { 
  toQueryString, 
  queryToJson, 
  toJsonString, 
  stringToJson, 
  formatDate, 
  arrayRemoveRepeatByProp, 
  isNullOrDefined,
  difference,
  differenceArrayByProp
};



// WEBPACK FOOTER //
// ./src/libs/utils/index.js